import { Helmet } from "react-helmet"
import { getTranslation } from "../../heplers/translationHelper"
import { useEffect, useState } from "react";
import { MyTable } from "../../components";
import AlertDialog from "../../components/DeleteDialog";
import { useSnackbar } from "notistack";
import { Get, Post } from "../../actions";
import { Box, Button, Typography } from "@material-ui/core";
import ButtonWithLoading from "../../components/ButtonWithLoading";
import { CloudDownload, PrintRounded } from "@material-ui/icons";
import { format } from "../../heplers/format";
import { exportToCSV } from "../../heplers/export";
import CloseServiceModal from "../Reservations/components/closeServiceModal";

export const ManageZcashList=()=>{
      const [queryParams, setQueryParams] = useState({
        pageSize: 10,
        pageNumber: 0,
        searchString: "",
      });
      const [openEditDialog, setOpenEditDialog] = useState(false);
      const [formData, setFormData] = useState(null);
      const [isLoadingCustomers, setIsLoadingCustomers] = useState(false);

     const [openDeleteModal, setOpenDeleteModal] = useState(false);
      const [isDeleting, setIsDeleting] = useState(false);
      const [isSubmitting, setIsSubmitting] = useState(false);
      const { enqueueSnackbar } = useSnackbar();
      const [customers, setCustomers] = useState({data:[],totalCount:0});
    
      const handlePageChange = (e, page) => {
        setQueryParams({ ...queryParams, pageNumber: page });
      };
    
      const handleSearch = (e) => {
        setQueryParams({ ...queryParams, searchString: e });
      };
    
      const handleRowsPerPageChange = (e) => {
        setQueryParams({ ...queryParams, pageSize: e.target.value });
      };
    
      const handleDelete = () => {
        setIsDeleting(true);
        Post(
          {id:formData.id},
          "Reservation/DeleteClosedService/",
          null,
          (res) => {
            setIsDeleting(false);
            enqueueSnackbar(
              getTranslation(
                "Deleted Successfully",
                "Deleted Successfully",
                "Deleted Successfully"
              ),
              {
                variant: "success",
              }
            );
            setOpenDeleteModal(false);
            setQueryParams({ ...queryParams, pageNumber: 0 });
          },
          (err) => {
            setIsDeleting(false);
            enqueueSnackbar(
              err.data
                ? err.data
                : getTranslation(
                    "Something went wrong. Please Try Again.",
                    "Something went wrong. Please Try Again.",
                    "Something went wrong. Please Try Again."
                  ),
              {
                variant: "error",
              }
            );
          }
        );
      };

      useEffect(()=>{
        Get(queryParams,
            "Reservation/GetAllClosedServicesPaged",
            null,
            resp=>{
                console.log("jkalhsdjkashdlkjas",resp)
                setCustomers(resp.data)
            },
            error=>{

            }
        )
      },[queryParams])

      const handleSubmitUpsert=(values)=>{
        setIsSubmitting(true)
       Post(
        values,
        "RestaurantUsers/Add",
        null,
        resp=>{
            setIsSubmitting(false)

        },
        error=>{
            enqueueSnackbar(getTranslation("User already exists."),{variant:"error"})
            setIsSubmitting(false)
        }
       )
      }

      const handleExport=()=>{
        Get({},
          "Reservation/GetAllClosedServices",
          null,
          resp=>{
              exportToCSV(resp.data.map(row=>({...row,date:format("date",row.createdAt),dayTime:row.dayTime==0? getTranslation("Morning"):getTranslation("Evening")})),["dayTime","persons","groups","eating","drinking","date"])
          },
          error=>{

          }
      )
      }
    
    return (
      <>
        <div>
          <Helmet>
            <title>
              {getTranslation("Manage Users", "Manage Users", "Manage Users")}
            </title>
          </Helmet>

          <MyTable
            title={getTranslation("Enteries", "Enteries", "Enteries")}
            loading={isLoadingCustomers}
            viewSearch
            onSearch={handleSearch}
            colums={columns}
            rowsPerPage={queryParams.pageSize}
            handleChangePage={handlePageChange}
            handleChangeRowsPerPage={handleRowsPerPageChange}
            page={queryParams.pageNumber}
            rows={customers.items}
            count={customers.totalItems}
            viewEdit
            onEdit={(row) => {
              setFormData(row);
              setOpenEditDialog(true);
            }}
              tableWidgets={
                      <>
                        <CloudDownload
                          color="secondary"
                          style={{ cursor: "pointer" }}
                          onClick={()=>handleExport()}
                        />
                        {/* <AddCircleOutline
                          color="secondary"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setIsEdit(false);
                            setShowReservationForm(true);
                          }}
                        /> */}
                        {/* <RiCloseCircleFill
                          style={{ cursor: "pointer" }}
                          color="secondary"
                          size={24}
                          onClick={() => setShowCloseService(true)}
                        /> */}
                      </>
                    }
            // onCreate={() => {
            //   setOpenEditDialog(true);
            //   setFormData({
            //     firstName: "",
            //     lastName: "",
            //     email: "",
            //     password:"",
            //     confirmPassword:""
            //   });
            // }}
            // viewCreate
            viewDelete
            onDelete={(row)=>{
              setFormData(row)
              setOpenDeleteModal(true)
            }}
          />
          <CloseServiceModal
          openDialog={openEditDialog}
          handleClose={()=>{
            setOpenEditDialog(false)
            setQueryParams({...queryParams})
          }}
          editModel={formData}
          onAdded={()=>setQueryParams({...queryParams})}
          />
          {/* <AddUser
            formData={formData}
            open={openEditDialog}
            onClose={() => {
              setOpenEditDialog(false);
              setFormData(null);
            }}
            onSubmit={handleSubmitUpsert}
          /> */}
          <AlertDialog
            open={openDeleteModal}
            onClose={() => setOpenDeleteModal(false)}
            deleting={isDeleting}
            onSubmit={handleDelete}
          />
          {/* <CustomersTable
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        isLoadingCustomers={isLoadingCustomers}
        stat={stat}
        customers={customers}
        formData={formData}
        setFormData={setFormData}
        setIsEdit={setIsEdit}
      /> */}
        </div>
      </>
    );
}

const columns = [
    {
      label: getTranslation("Date", "Date", "Date"),
      id: "date",
      component: ({ row }) => <Typography>{format("date", row.createdAt)}</Typography>,
    },
    {
      label: getTranslation("Day Time", "Day Time", "Day Time"),
      id: "date",
      component: ({ row }) => <Typography>{row.dayTime==0?getTranslation("Morning"):getTranslation("Evening")}</Typography>,
    },
  {
    label: getTranslation("# Persons", "# Persons", "# Persons"),
    id: "Roles",
    align:"right",
    component: ({ row }) => <Typography align="right">{format("number" , row.persons)}</Typography>,
  },
    {
      label: getTranslation("# Tables", "# Tables", "# Tables"),
      id: "email",
    align:"right",
    component: ({ row }) => <Typography align="right">{format("number" , row.groups)}</Typography>,
    },
    {
      label: getTranslation("# Eatings", "# Eatings", "# Eatings"),
      id: "email",
    align:"right",
    component: ({ row }) => <Typography align="right">{format("number", row.eating)}</Typography>,
    },
    {
      label: getTranslation("# Drinking", "# Drinking", "# Drinking"),
      id: "email",
    align:"right",
    component: ({ row }) => <Typography align="right">{format("number",row.drinking)}</Typography>,
    },
    {
      label: getTranslation("Actions", "Actions", "Actions"),
      id: "actions",
    },
  ];